import { ajax } from '@utils/ajax';

export default (invoiceIds) => {
	return ajax.get(`/settings/account/billing/invoices/export`, { invoiceIds })
		.then(({ data }) => data);
};
